import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const RefreshIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			d="M11.9746 13.9429C10.5728 14.8076 8.93899 15.1566 7.32926 14.9351C5.71953 14.7137 4.22485 13.9342 3.07946 12.719C2.14332 11.7258 1.48375 10.4874 1.16333 9.1391C1.04844 8.65566 1.43724 8.22003 1.93437 8.22003C2.34387 8.22003 2.68633 8.52067 2.79369 8.91566C3.05809 9.88836 3.55163 10.7802 4.23422 11.5044C5.1251 12.4496 6.28767 13.0558 7.53972 13.2281C8.79177 13.4004 10.0625 13.1289 11.1529 12.4563C11.3402 12.3408 11.5204 12.2145 11.6927 12.0783L10.4444 10.7522C10.094 10.3799 10.358 9.76914 10.8694 9.76914L14.4164 9.76914C14.7387 9.76914 15 10.0303 15 10.3525V14.0248C15 14.5424 14.3757 14.8036 14.0068 14.4404L12.8542 13.3054C12.5774 13.5391 12.2835 13.7523 11.9746 13.9429Z"
		></path>
		<path
			fill="currentColor"
			d="M4.02678 2.09145C5.42926 1.19864 7.06381 0.838337 8.67428 1.067C10.2848 1.29567 11.7801 2.10038 12.926 3.35502C13.8697 4.38819 14.5324 5.67838 14.8503 7.08261C14.9597 7.56632 14.5712 8 14.0751 8C13.6639 8 13.3202 7.6973 13.2166 7.29958C12.9532 6.28841 12.4577 5.36118 11.7708 4.60907C10.8795 3.63321 9.71635 3.0073 8.46372 2.82944C7.21109 2.65158 5.93973 2.93183 4.84889 3.62626C4.66149 3.74556 4.48124 3.87592 4.30881 4.01649L5.5577 5.38566C5.90831 5.77003 5.64411 6.40062 5.13246 6.40062L1.58387 6.40062C1.26141 6.40062 1 6.13098 1 5.79836L1 2.00685C1 1.47246 1.62458 1.20278 1.99364 1.57782L3.14675 2.74964C3.42376 2.50837 3.71771 2.2882 4.02678 2.09145Z"
		></path>
	</svg>
))
